/**
 * @param {Date} date
 */
export function toIsoDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function todayIso() {
  return toIsoDate(new Date())
}

/**
 * @param {string} isoDate
 * @param {number} offsetDays
 */
export function shiftIsoDate(isoDate, offsetDays) {
  const date = new Date(`${isoDate}T12:00:00`)
  date.setDate(date.getDate() + offsetDays)
  return toIsoDate(date)
}

/**
 * @param {string} isoDate
 */
export function nextIsoDate(isoDate) {
  return shiftIsoDate(isoDate, 1)
}

/**
 * @param {string} isoDate
 */
export function formatDayHeading(isoDate) {
  return new Date(`${isoDate}T12:00:00`).toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

/**
 * Compact workspace date: Thu, 10 Sep 2026
 *
 * @param {string} isoDate
 */
export function formatScheduleDate(isoDate) {
  return new Date(`${isoDate}T12:00:00`).toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

/**
 * Anchor date plus the next two days (operational 3-day view).
 *
 * @param {string} anchorDate YYYY-MM-DD
 * @returns {{ dates: string[], from: string, to: string }}
 */
export function buildThreeDayRange(anchorDate) {
  const dates = [anchorDate, shiftIsoDate(anchorDate, 1), shiftIsoDate(anchorDate, 2)]

  return {
    dates,
    from: dates[0],
    to: nextIsoDate(dates[2]),
  }
}
